import apiClient from './apiClient';

const normalizePlaybook = (p) => ({
  ...p,
  isActive: p?.isActive ?? p?.is_active ?? false,
  triggerType: p?.triggerType ?? p?.trigger_type ?? 'UNKNOWN',
  steps: (p?.steps || []).map((s) => s?.actionType ?? s?.action_type ?? s),
  executionsThisWeek: Number(p?.executionsThisWeek ?? p?.executions_this_week ?? 0)
});
const normalizeExecution = (e) => ({
  ...e,
  playbookId: e?.playbookId ?? e?.playbook_id,
  playbookName: e?.playbookName ?? e?.playbook_name ?? e?.playbook_id ?? 'Playbook',
  triggerSource: e?.triggerSource ?? e?.trigger_source ?? '—',
  status: String(e?.status || 'QUEUED').toLowerCase(),
  stepCount: Number(e?.stepCount ?? e?.step_count ?? 0),
  startedAt: e?.startedAt ?? e?.started_at ?? e?.createdAt ?? e?.created_at,
  createdAt: e?.createdAt ?? e?.created_at
});

export async function fetchPlaybooks() {
  const { data } = await apiClient.get('/automation-engine/playbooks');
  return data.map(normalizePlaybook);
}

export async function fetchExecutions() {
  const { data } = await apiClient.get('/automation-engine/executions');
  return data.map(normalizeExecution);
}

export async function setPlaybookActive(id, isActive) {
  const { data } = await apiClient.patch(`/automation-engine/playbooks/${id}`, { is_active: isActive });
  return normalizePlaybook(data);
}

export async function approveExecution(id) {
  const { data } = await apiClient.post(`/automation-engine/executions/${id}/approve`);
  return normalizeExecution(data);
}

export async function rejectExecution(id) {
  const { data } = await apiClient.post(`/automation-engine/executions/${id}/reject`);
  return normalizeExecution(data);
}

export async function fetchTriggerLog() {
  const { data } = await apiClient.get('/automation/trigger-log');
  return data;
}
